'use client';

import { Controller, FieldError, useFormContext } from 'react-hook-form';
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from '@/components/ui/select';
import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

interface Option {
  label: string;
  value: string;
}

interface FormSelectProps {
  name: string;
  options: Option[];
  placeholder?: string;
  rules?: any;
  required?: boolean;
}

const FormSelect: FC<FormSelectProps> = ({
  name,
  options,
  placeholder,
  rules,
  required,
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const error = errors[name] as FieldError | undefined;

  return (
    <div className='space-y-1'>
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field }) => (
          <>
            <Select
              onValueChange={field.onChange}
              value={field.value}
              required={required}>
              <SelectTrigger
                onBlur={field.onBlur}
                className={twMerge(
                  'rounded-full h-12 border-2 p-3',
                  error ? 'border-red-500' : 'border-black/70'
                )}>
                <SelectValue placeholder={placeholder} />
              </SelectTrigger>
              <SelectContent>
                {options.map(option => (
                  <SelectItem key={option.value} value={option.value}>
                    {option.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            {error?.message && (
              <p className='text-xs text-red-500'>{error.message}</p>
            )}
          </>
        )}
      />
    </div>
  );
};

export default FormSelect;
